import React from 'react';
import { Col, Row, FullRow } from '../framework/Grid';
import AcquireWebComponent from '../framework/MaterialUI';
import isEmpty from 'lodash/isEmpty';
import { splitNumber } from '../../utils/utility'

class ClientUnits extends AcquireWebComponent {
	render() {
		const {title, data, footer} = this.props;
		if (isEmpty(data)) {
			return (
				<div style={{ float: "left", width: "100%", position: "relative" }}>
					<div style={{ fontSize: '16px', lineHeight: '18px', fontWeight:'bold' }}>{title}</div>
					<div style={{ width: '100%', minHeight: '190px', textAlign: 'center', paddingTop: '50px', color: "#CDCDCD" }}>
						<div style={{ color: "#CDCDCD", fontSize: '28pt', opacity: '0.8' }}>No Data</div>
					</div>		
				</div>
			)
		} else {
			return (
				<div className="client-units-container">
					<div style={{ fontSize: '24px', lineHeight: '28px', fontWeight:'bold' }} className="mb-10">{title}</div>
					<Row className="no-padding-left pt-10" style={{fontSize:'16px'}}>
						<Col xs="6" sm="6" md="6" lg="6" className="light-grey-right-border pr-20">
							<div style={{height:'18px', marginBottom: '20px'}}>
								<span style={{width:'60%', textAlign:'left'}}>Total Clients:</span>
								<span style={{width:'40%'}} className="text-right pull-right">{ splitNumber(data.totalClients)()}</span>
							</div>
							<div style={{height:'18px', marginBottom: '20px'}}>
								<span style={{width:'60%', textAlign:'left'}}>Join Last 30 Days: </span>
								<span style={{width:'40%'}} className="text-right pull-right">{splitNumber(data.clientsJoinLastMonth)()}</span>
							</div>
							<div style={{lineHeight:'16px'}} className="light-grey-bottom-border pt-15 pb-15 light-grey-top-border">
								<span style={{width:'60%', textAlign:'left'}}>Client Users:</span>
								<span style={{width:'40%'}} className="text-right pull-right">{splitNumber(data.clientUsers)()}</span>
							</div>
						</Col>
						<Col xs="6" sm="6" md="6" lg="6" className="pl-20">
							<div style={{height:'18px', marginBottom:'20px'}}>
								<span style={{width:'60%', textAlign:'left'}}>Total Business Units:</span>
								<span style={{width:'40%'}} className="text-right pull-right">{splitNumber(data.totalBizUnit)()}</span>
							</div>
							<div style={{height:'18px', marginBottom: '20px'}}>
								<span style={{width:'60%', textAlign:'left'}}>Join Last 30 Days: </span>
								<span style={{width:'40%'}} className="text-right pull-right">{splitNumber(data.bizUnitJoinLastMonth)()}</span>
							</div>
							<div style={{lineHeight:'18px'}} className="light-grey-bottom-border pt-15 pb-15 light-grey-top-border ">
								<span style={{width:'60%', textAlign:'left'}}>Business unit Users:</span>
								<span style={{width:'40%'}} className="text-right pull-right">{splitNumber(data.bizUnitUsers)()}</span>
							</div>
						</Col>
					</Row>
					{
						footer && (
							<FullRow className="pl-10">
								{footer}
							</FullRow>
						)
					}

				</div>				
			)
		}

	}
}

export default ClientUnits


// WEBPACK FOOTER //
// ./src/components/Dashboard/client-units.jsx